import { computed, inject, Injectable } from '@angular/core';
import { UserService } from '../../features/user-management/services/user.service';
import { USER_TEMP_ROLES_ID } from '../../features/user-management/constants/user-temp-roles';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {

  private readonly userService = inject(UserService);
  private readonly isPartnerAdmin = computed(() => {
    const roles = this.userService.user()?.roles ?? [];
    return roles.some(role => role.id === USER_TEMP_ROLES_ID.partnerAdmin);
  });
  readonly canAccessAllProjects = computed(() => this.isPartnerAdmin());
  readonly canAccessUserManagement = computed(() => this.isPartnerAdmin());
}
